<script setup>
import Default from '@/Layouts/Default.vue';
import ProviderHeader from '@/Components/Content/Header/Provider.vue';
import Content from '@/Components/Content/index.vue';
import CourseListItem from '@/Components/List/Item/Course.vue';
import PaginatedList from '@/Components/List/Paginated.vue';
import { computed } from 'vue';
import { Head, usePage } from '@inertiajs/vue3';

const props = defineProps({
  courses: {
    type: Object,
    required: true,
  },
  provider: {
    type: Object,
    required: true,
  },
  queryObject: {
    type: Object,
    required: true,
  }
});

const page = usePage();

const context = computed(() => page.props?.context);
const providerName = context.value.name;
</script>


<template>
  <Head>
    <title>Courses at {{ props.provider.name }} - {{ providerName }}</title>
    <meta name="description" :content="`Courses at ${props.provider.name} - ${providerName}`">
  </Head>
  <Default>
    <Content content-type="list">
      <template #header>
        <ProviderHeader :provider="provider" />
      </template>
      <template #content>
        <PaginatedList
          :slug="`provider/${provider.slug}/${provider.id}/courses`"
          list-name="courses"
          :current-page="courses.meta?.page ?? 1"
          :total-results="courses.meta?.total ?? 0"
          :query-object="queryObject"
        >
          <CourseListItem
            v-for="course, index in courses.data"
            :key="`course-${index}`"
            :course="course"
          />
        </PaginatedList>
      </template>
    </Content>
  </Default>
</template>
